import { render, staticRenderFns } from "./inspectionReportDetail.vue?vue&type=template&id=1745003c&scoped=true&"
import script from "./inspectionReportDetail.vue?vue&type=script&lang=js&"
export * from "./inspectionReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./inspectionReportDetail.vue?vue&type=style&index=0&id=1745003c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1745003c",
  null
  
)

export default component.exports